import { Chart as ChartJS } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Registrar plugin global
ChartJS.register(ChartDataLabels);

export const chartTheme = {
  colors: {
    primary: '#18181b',      // ink-900 - Líneas principales
    secondary: '#71717a',    // ink-500 - Líneas secundarias
    tertiary: '#a1a1aa',     // ink-400 - Grids y ejes
    accent: '#dc2626',       // accent - Datos críticos

    // Estados de alerta (mantener colores funcionales)
    success: '#22c55e',      // Verde para alertas verdes
    warning: '#eab308',      // Amarillo para alertas amarillas
    error: '#ef4444',        // Rojo para alertas rojas
    info: '#3b82f6',         // Azul para información

    // Backgrounds
    gridLines: '#e4e4e7',    // ink-200
    tooltipBg: '#18181b',    // ink-900
    chartBg: '#ffffff',
  },
  fonts: {
    family: '"Instrument Sans", system-ui, sans-serif',
    size: 12,
    lineHeight: 1.5,
  }
};

export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: {
          family: chartTheme.fonts.family,
          size: chartTheme.fonts.size,
        },
        color: chartTheme.colors.secondary,
        padding: 15,
        usePointStyle: true,
        boxWidth: 8,
        boxHeight: 8,
      }
    },
    tooltip: {
      backgroundColor: chartTheme.colors.tooltipBg,
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      padding: 12,
      borderColor: chartTheme.colors.gridLines,
      borderWidth: 1,
      cornerRadius: 8,
      displayColors: true,
      titleFont: {
        family: chartTheme.fonts.family,
        size: 13,
        weight: '600',
      },
      bodyFont: {
        family: chartTheme.fonts.family,
        size: 12,
      }
    },
    datalabels: {
      display: false, // Desactivar por defecto
    }
  },
  scales: {
    x: {
      grid: {
        color: chartTheme.colors.gridLines,
        drawBorder: false,
      },
      ticks: {
        color: chartTheme.colors.secondary,
        font: {
          family: chartTheme.fonts.family,
          size: 11,
        }
      }
    },
    y: {
      grid: {
        color: chartTheme.colors.gridLines,
        drawBorder: false,
      },
      ticks: {
        color: chartTheme.colors.secondary,
        font: {
          family: chartTheme.fonts.family,
          size: 11,
        }
      },
      beginAtZero: true,
    }
  }
};

// Plugin personalizado para texto en centro de doughnut
export const centerTextPlugin = {
  id: 'centerText',
  afterDraw: (chart) => {
    if (chart.config.options.plugins.centerText) {
      const { ctx, chartArea: { width, height } } = chart;
      const { text, subtext } = chart.config.options.plugins.centerText;

      ctx.save();
      ctx.font = `bold 24px ${chartTheme.fonts.family}`;
      ctx.fillStyle = chartTheme.colors.primary;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, width / 2, height / 2 - 10);

      if (subtext) {
        ctx.font = `12px ${chartTheme.fonts.family}`;
        ctx.fillStyle = chartTheme.colors.secondary;
        ctx.fillText(subtext, width / 2, height / 2 + 15);
      }

      ctx.restore();
    }
  }
};

ChartJS.register(centerTextPlugin);
